import { createFileRoute } from '@tanstack/react-router';
import { MasterAccountingTypesPage } from '@/pages/master-management/ui/MasterAccountingTypesPage';
import { paginationSchema, routeValidateQuerySearch } from '@/shared/lib/route';

export const Route = createFileRoute('/_protected/master/accounting-types')({
  component: MasterAccountingTypesPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      withPaginationSchema: paginationSchema,
      defaultValues: undefined,
    }),
});
